var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Bitrate Info (last event)",
            width: "60%",
            top: "10px",
            visible: _vm.visible,
          },
          on: {
            "update:visible": function ($event) {
              _vm.visible = $event
            },
          },
        },
        [
          _c("div", { staticStyle: { padding: "0px 10px 20px 10px" } }, [
            _vm.loadingBitRate
              ? _c("div", [
                  _c("div", { staticStyle: { "text-align": "center" } }, [
                    _c("i", { staticClass: "el-icon-loading" }),
                    _vm._v(
                      " Looking last event and loading bitrate information...\n        "
                    ),
                  ]),
                ])
              : _c("div", [
                  _vm.error
                    ? _c("div", [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              color: "red",
                              "text-align": "center",
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.error) +
                                "\n          "
                            ),
                          ]
                        ),
                      ])
                    : _c("div", [
                        _c("div", { staticStyle: { "text-align": "center" } }, [
                          _c("h2", { staticStyle: { margin: "0px" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("uppercase")(_vm.currentEvent.type)
                                ) +
                                " - " +
                                _vm._s(_vm.currentEvent.ding_id) +
                                "\n            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c("h3", { staticStyle: { margin: "0px" } }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("moment")(
                                    _vm.currentEvent.created_at,
                                    "MMMM Do YYYY, h:mm a"
                                  )
                                ) +
                                "\n            "
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticStyle: { overflow: "scroll" } },
                          [
                            _c(
                              "el-row",
                              { attrs: { gutter: 20 } },
                              _vm._l(_vm.bitrateData, function (value, key) {
                                return _c(
                                  "el-col",
                                  { key: key, attrs: { span: 24 } },
                                  [
                                    _c(
                                      "el-link",
                                      {
                                        attrs: {
                                          href:
                                            "data:image/svg+xml;base64," +
                                            value,
                                          target: "_blank",
                                        },
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            src:
                                              "data:image/svg+xml;base64," +
                                              value,
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                ]),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "el-button",
        {
          staticStyle: { "margin-right": "5px", "min-width": "100%" },
          attrs: {
            slot: "reference",
            plain: "",
            type: _vm.visible ? "info" : "success",
            size: "mini",
          },
          on: {
            click: function ($event) {
              _vm.visible = !_vm.visible
            },
          },
          slot: "reference",
        },
        [_vm._v("\n    Bitrate\n  ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }